"use client";
import React, { RefObject } from "react";
import StylesNSBox from "./NSBox.module.css";
import { IValidationProps } from "../props/IValidationProps";
import { IValidationStringProps } from "../props/IValidationStringProps";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { NSLabelErrorNotifier } from "./NSLabelErrorNotifier";
import { NSMenuButton, NSMenuButtonMenuProps, NSMenuButtonProps } from "./NSMenuButton";

export interface INSBoxBaseLayoutProps<Box, Data> 
{
	title: string;
	description?: string;
	placeholder?: string;
	defaultValue?: Data;
	hideHeader?: boolean;
	onChanged?: (e: Box) => void;
	onClicked?: (e: Box) => void;
	onEnterPressed?: () => void;
	menu?: NSMenuButtonMenuProps;
}

export interface NSBoxBaseLayoutProps extends IBaseComponentProps, IValidationProps, IValidationStringProps, NSMenuButtonProps
{
	title: string;
	hideHeader?: boolean;
	children: React.ReactNode;
	onEnterPressed?: () => void;
}

export interface NSBoxBaseLayoutState
{
	error?: string;
}

export class NSBoxBaseLayout extends React.Component<NSBoxBaseLayoutProps, NSBoxBaseLayoutState>
{
	static checkGetValue<T>(box: { NSBoxBaseLayout_Main: RefObject<NSBoxBaseLayout>, getError: () => string | null }, checkError: boolean, handler: () => T | null): T | null
	{
		return box.NSBoxBaseLayout_Main.current?._onGetValue(checkError, box.getError, handler) ?? null;
	}
	constructor(props: NSBoxBaseLayoutProps)
	{
		super(props);
		this.state = { error: "" };
		this._onGetValue = this._onGetValue.bind(this);
	}
	private _onGetValue<T>(checkError: boolean, getError: () => string | null, handler: () => T): T
	{
		if (checkError)
		{
			let error = getError();
			if (error)
			{
				this.setState({ error });
				throw new Error(error);
			}
		}
		return handler();
	}
	override render()
	{
		return (
			<>
				<div
					id={this.props.id}
					className={`${StylesNSBox.ns_box_input_parent} ${this.props.classList?.join(" ") ?? ""}`}
					style={this.props.style}
					onKeyUp={e =>
					{
						if (e.key === "Enter")
							this.props.onEnterPressed?.();
					}}
				>
					{
						!this.props.hideHeader && <div className={`${StylesNSBox.ns_box_input_bar}`}>
							<span className={StylesNSBox.ns_box_input_title}>
								{this.props.required && <span style={{ color: "red" }}>*</span>} {this.props.title}
							</span>
							<NSMenuButton description={this.props.description} menu={this.props.menu} />
						</div>
					}
					{this.props.children}
					<NSLabelErrorNotifier error={this.state.error} clearError={() => this.setState({ error: undefined })} />
				</div>
			</>
		);
	}
}